import { gql } from '@apollo/client';

import { SupplierDocument } from '../../types';

interface SupplierDocs {
  documents: Array<SupplierDocument>;
}

export interface SupplierDocuments {
  supplierDocs: SupplierDocs;
}

export const SUPPLIER_DOCUMENTS = gql`
  query($supplierId: String!) {
    supplierDocs(supplierId: $supplierId) {
      documents {
        fileName
        fileType
        expiryDate
        key
        url
      }
    }
  }
`;
